import React from "react";
import Route from "./Routes/routeIndex";

//import Custom Style scss
import "./assets/scss/theme.scss";

function App() {
  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
